import { useContext, useEffect } from 'react'
import { Chart } from 'primereact'
import React, { useState } from 'react'
import { Button } from 'primereact/button';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import Card from '../../../Base/Components/Card/Card'
import Loader from '../../../Base/Components/Loader/Loader'
import { ConfigContext } from '../../../Base/Context/ConfigContext/ConfigContext';

import { getHeadCount } from '../../../API/RRHH/KPIs/HeadCountsRequtets'

import { borderColorCotton, borderColorSintetico, getScales, getTitle } from '../../../utils/KPIs/productionUtils';
import './headCount.scss'
import { baseLang } from '../../../Base/Lang/BaseLang';
import { getLabel } from '../../../Base/Services/Language/LanguageService';


const HeadCountScreen = ({ kpiGerencia, fecha, buscar , setShowPersonal}) => {

    const { config } = useContext(ConfigContext);

    const scales = getScales(config);
    const colorTitle = getTitle(config);


    let Mes = fecha.toLocaleString('es-ES', { month: 'long' })
    const monthName = Mes.charAt(0).toUpperCase() + Mes.slice(1);


    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({})
    const [char, setChar] = useState({
        // interaction: {
        // intersect: false,
        // mode: 'index',
        // },
    })


    const getInfo = async () => {
        setLoading(true);
        const mes = fecha.getMonth() + 1;
        const ano = fecha.getFullYear();
        const t = await getHeadCount(mes, ano);

        // console.log(t)

        setData(t);
        // console.log(t);
        // setChar({
        //     ...char,
        //     labels: [''],
        //     datasets: [
        //         {
        //             type: 'bar',
        //             label: 'MO Indirecta',
        //             backgroundColor: colorCotton,
        //             borderColor: borderColorCotton,
        //             borderWidth: 2,
        //             data: [t.MI],
        //             stack: 'Stack 0',
        //             borderRadius: borderRadius,
        //             color: 'white'
        //         },
        //         {
        //             type: 'bar',
        //             label: 'MO Directa',
        //             backgroundColor: colorSintetico,
        //             borderColor: borderColorSintetico,
        //             borderWidth: 2,
        //             data: [t.MD],
        //             stack: 'Stack 1',
        //             borderRadius: borderRadius,
        //         },
        //         {
        //             type: 'bar',
        //             label: 'Ingresos',
        //             backgroundColor: borderColorCotton,
        //             borderColor: borderColorCotton,
        //             borderWidth: 2,
        //             data: [t.ingresos],
        //             stack: 'Stack 3',
        //             borderRadius: borderRadius,
        //         },
        //         {
        //             type: 'bar',
        //             label: 'Salidas',
        //             backgroundColor: borderColorSintetico,
        //             borderColor: borderColorSintetico,
        //             borderWidth: 2,
        //             data: [t.egresos],
        //             stack: 'Stack 4',
        //             borderRadius: borderRadius,
        //         },
        //     ],
        //     plugins: {
        //         title: {
        //             display: true,
        //             text: 'Activos: ' + (t.MD + t.MI) + ' ',
        //             color: colorTitle,
        //         },
        //         datalabels: {...datalabelsBarTop, color: colorTitle},
        //         tooltip: {
        //             callbacks: {
        //                 footer: (tooltipItems) => {
        //                     return 'Total Activo: ' + ((tooltipItems[0].raw + tooltipItems[1].raw)) 
        //                 },
        //             }
        //         },
        //     },
        //     scales: scales,
        // })
        setChar({
            // ...char,
            labels: ['MOD', 'MOI'],
            datasets: [
                {
                    // type: 'doughnut',
                    // label: ['MOI', 'MOD'],
                    label: '',
                    backgroundColor: [borderColorCotton, borderColorSintetico],
                    // borderColor: borderColorCotton,
                    // borderWidth: 2,
                    data: [t.MI, t.MD],
                    // stack: 'Stack 0',
                    // borderRadius: borderRadius,
                    color: 'white'
                },
            ],
            plugins: {
                title: {
                    display: false,
                    text: 'Head Count' + (t.MD + t.MI) + '  ',
                    color: colorTitle,
                },
                legend: {
                    display: false,
                },
                datalabels: {
                    alert: 'center',
                    color: 'white',
                    font: {
                        weight: 'bold'
                    },
                    align: 'center',
                    // offset: 10,
                    // arrowWidth: 10,
                    // arrowHeight: 10,
                    formatter: (value, context) => {
                        return (context.dataIndex === 1 ? 'MOD' : 'MOI') + '\n' + value
                    },
                },
                tooltip: {
                    callbacks: {
                        footer: (tooltipItems) => {
                            return 'Head Count: ' + ((t.MD + t.MI))
                        },
                    }
                },
            },
            // scales: scales,
        })
        setLoading(false);
    }

    useEffect(() => {
        getInfo();
    }, [])

    useEffect(() => {
        if (buscar) {
            getInfo();
        }
    }, [buscar])

    return (
        <div >

            {kpiGerencia ? 
                <Card
                    style={{height: '262px'}}
                    titulo={
                        <div>
                            {kpiGerencia &&(
                                <div className='d-flex'>

                                    <h4 className='mt-2'>Head Count {data.MI + data.MD}</h4>
                                    <Button
                                    style={{ zIndex: 1000 }}
                                    className="p-button-text mx-2"
                                    tooltip={getLabel(baseLang, "personalTotal", config.language)}
                                    icon='pi pi-eye'
                                    onClick={() => { setShowPersonal(true); }}
                                    />
                                </div>
                            )}
                        </div>
                    }
                    contenido={<div className={'p-0 mt-4'}>
                        <Loader loading={loading} />
                        <div>
                            <div>
                                {/* <h5 className='text-bold' style={{ textAlign: 'center' }}>Head Count {data.MI + data.MD}</h5> */}
                                <h6 className='bold' style={{ textAlign: 'center', fontSize: '0.85rem', fontWeight: 'bold' }}>
                                    {monthName} / {fecha.getFullYear()}
                                </h6>
                            </div>
                            <div className='d-flex' style={{ flexDirection: 'row', justifyContent: 'space-evenly' }}>
                                <div style={{ width: 150, height: 150, position: 'relative' }}>
                                    <div className='chart'>
                                        <Chart height={150} width={150} type="doughnut" data={char} options={char} plugins={[ChartDataLabels]} />
                                    </div>
                                    <div className='iconHeadCount'>
                                        <i className="pi pi-users" style={{ 'fontSize': '4em' }}></i>
                                    </div>
                                </div>
                                <div className='info mt-10'>
                                    <div className="d-flex fila in">
                                        <div className='col-4 mx-2'>
                                            <i className='ri-arrow-left-circle-line in' />
                                        </div>
                                        <div className='col-9'>
                                            {data.ingresos} Ingresos
                                        </div>
                                    </div>
                                    <div className="d-flex fila out">
                                        <div className='col-4 mx-2'>
                                            <i className='ri-arrow-right-circle-line out' />
                                        </div>
                                        <div className='col-9'>
                                            {data.egresos} Salidas
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}
                /> : 

                <div className='headCountClass'>    
                    <Card
                        style={{height: '262px'}}
                        titulo={
                            <div className='d-flex'>
                                <h4 className='mt-2'>Head Count</h4>
                            </div>
                        }
                        contenido={<div className={'p-0 mt-4'}>
                            <Loader loading={loading} />
                            <div>
                                <div className='d-flex' style={{ flexDirection: 'row', justifyContent: 'space-evenly' }}>
                                    <div style={{ width: 150, height: 150, position: 'relative' }}>
                                        <div className='chart' style={{ marginTop: '35px' }}>
                                            <Chart height={150} width={150} type="doughnut" data={char} options={char} plugins={[ChartDataLabels]} />
                                        </div>
                                        <div className='iconHeadCount'>
                                            <i className="pi pi-users" style={{ 'fontSize': '4em' }}></i>
                                        </div>
                                    </div>
                                    <div className='info'>
                                        <div className="d-flex fila in">
                                            <div className='col-4 mx-2'>
                                                <i className='ri-arrow-left-circle-line in' />
                                            </div>
                                            <div className='col-9'>
                                                {data.ingresos} Ingresos
                                            </div>
                                        </div>
                                        <div className="d-flex fila out">
                                            <div className='col-4 mx-2'>
                                                <i className='ri-arrow-right-circle-line out' />
                                            </div>
                                            <div className='col-9'>
                                                {data.egresos} Salidas
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>}
                    />
                </div>
            }
        </div>
    )
}

export default HeadCountScreen